export function checkLuhn(value) {
    if (!value.length) {
        return false;
    }
    const lastDigit = Number(value[value.length - 1]);
    const reverseValue = value
        .slice(0, value.length - 1)
        .split('')
        .reverse()
        .map((x) => Number(x));
    for (let i = 0; i <= reverseValue.length - 1; i += 2) {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        reverseValue[i] *= 2;
        const chkValue = reverseValue[i];
        if (chkValue && chkValue > 9) {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            reverseValue[i] -= 9;
        }
    }
    const sum = reverseValue.reduce((acc, currValue) => acc + currValue, 0);
    return (sum + lastDigit) % 10 === 0;
}
